import React, { useState } from 'react';
import axios from 'axios';
import { CSSTransition } from 'react-transition-group';
import { useHistory } from 'react-router';
//Components
import { BackDropModal, PopupModal } from '../../../Modals/Index';
import { useUser } from '../../../Context/User';
import { LabeledInput, NotificationMessage } from '../../../Components/index';
//Assests//
import './style.css';
import SearchIcon from '@material-ui/icons/Search';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import CloseIcon from '@material-ui/icons/Close';
import Logo from '../../../Assets/Photos/Logo.png';
import Bell from '../../../Assets/Photos/Notification.png';
import Wallet from '../../../Assets/Photos/Wallet.png';
import User from '../../../Assets/Photos/Avatar.png';
//Helpers//
import LoadScript from '../../../Helpers/LoadScript';

const Index = ({ sidebar, setSidebar }) => {
    const hist = useHistory();

    const { logout, role, profile, walletMoney, name, addMoney } = useUser();
    const [alert, setAlert] = useState(false);
    const [showNoti, setShowNoti] = useState(false);
    const [searchPopup, setSearchPopup] = useState(false);
    const [profilePopup, showProfilePopup] = useState(false);
    const [topup, setTopup] = useState(false);
    const [money, setMoney] = useState(100);

    ////////////////////
    // Search Handler
    ////////////////////

    const onSearchClickhandler = (inner) => {
        if (inner || !window.matchMedia('max-width: 450px').matches) {
            console.log('Search');
        } else {
            setSearchPopup((prev) => !prev);
        }
    };

    ////////////////////
    //Alert Ntoification
    ////////////////////

    const setAlertNotification = (message) => {
        setAlert(message);
        setTimeout(() => {
            setAlert(false);
        }, 1500);
    };

    ////////////////////
    //Razor Pay Online Payment
    ////////////////////

    ////////////////////
    //Razor Pay Online Payment
    ////////////////////

    async function displayRazorpay() {
        ////////////////////
        //Loading Razor Pay When Reqiure
        ////////////////////
        // setTopup(true);
        const res = await LoadScript('https://checkout.razorpay.com/v1/checkout.js');

        if (!res) {
            setAlertNotification('Razorpay SDK failed to load. Are you online?');
            return;
        }

        ////////////////////
        // Calculating The prices
        ////////////////////
        const price = (parseInt(money) * 100).toString();
        ////////////////////
        // Setting up Options for Razorpay
        ////////////////////

        const options = {
            key: process.env.REACT_APP_RAZORPAY_API_KEY,
            currency: 'INR',
            amount: price,
            // order_id: 'AEDE45FVCZA235C',
            name: 'Cogminds Wallet Topup',
            description: 'Please Continue to Topup',
            image: Logo,
            ////////////////////
            // Handler functions after Payment response....
            ////////////////////
            handler: async function (response) {
                // const newdate = new Date();
                ////////////////////
                // Calling Backend for the User Wallet Update
                ////////////////////

                setAlertNotification('Topup Sucessfull!');
                addMoney(parseInt(money));
                // setTopup(false);
            },

            prefill: {
                name: 'My Test Name',
                email: 'test@email.com',
                phone_number: '+91-9876543211',
            },
        };

        ////////////////////
        // Opening the Razorpaymodal....
        ////////////////////

        const paymentObject = new window.Razorpay(options);
        paymentObject.open();

        ////////////////////
        // Handling Razoroay Modal open failed
        ////////////////////

        paymentObject.on('payment.failed', function (response) {
            // console.log(response);
            setAlertNotification('Topup Failed!');
            // setTopup(false);
            // console.log('Payment failed');
        });
    }

    return (
        <header className="header">
            <div onClick={() => setSidebar((prev) => !prev)} className={`header_menu ${sidebar ? 'active_menu' : ''}`}>
                <p className={`header_menu_icon`} />
            </div>
            <CSSTransition in={alert !== false} timeout={20} unmountOnExit classNames="header_notifcation_panel">
                <div className="alert_box">{alert}</div>
            </CSSTransition>
            <PopupModal
                state={topup}
                setStateFalse={() => {
                    setTopup(false);
                }}
            >
                <div style={{ width: 'max-content' }} className="popupConatiner">
                    <div className="home_head flex-start">
                        <div className="home_head">
                            <div>
                                <h2 className="home_heading">Enter Topup Amount</h2>
                            </div>
                        </div>
                    </div>
                    <form className="password-popup" action={`submit`}>
                        <LabeledInput
                            style={{ width: '100%', maxWidth: '280px' }}
                            name="money"
                            type="number"
                            value={money}
                            changeHandler={(e) => {
                                setMoney(e.target.value);
                            }}
                            label={'Enter Amount'}
                        />
                        <div className="password-popup_footer">
                            <button
                                type="reset"
                                onClick={() => {
                                    setTopup(false);
                                }}
                                className="btn-gray"
                                style={{ marginRight: '1rem' }}
                            >
                                <p>Close</p>
                            </button>
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    setTopup(false);
                                    displayRazorpay();
                                }}
                                type="submit"
                                className="btn-orange"
                            >
                                <p>Continue</p>
                            </button>
                        </div>
                    </form>
                </div>
            </PopupModal>
            <PopupModal
                state={searchPopup}
                setStateFalse={() => {
                    setSearchPopup(false);
                }}
            >
                <div className="header_search_modal">
                    <SearchIcon
                        onClick={() => {
                            onSearchClickhandler(true);
                        }}
                        className="header_search_icon_modal"
                    />
                    <input className="header_search_input_modal" type="text" placeholder="Enter Product or Order..." />
                </div>
            </PopupModal>
            <div className="header_search">
                <SearchIcon
                    onClick={() => {
                        onSearchClickhandler(false);
                    }}
                    className="header_search_icon"
                />
                <input className="header_search_input" type="text" placeholder="Enter Product or Order..." />
            </div>
            <div className="header_right">
                <div className="header_notification">
                    <img
                        onClick={() => {
                            setShowNoti((prev) => !prev);
                        }}
                        className="header_notification_image"
                        src={Bell}
                        alt="Noti"
                    />
                    <p className="header_notification_count">3</p>
                    <CSSTransition in={showNoti} timeout={200} unmountOnExit classNames="header_notifcation_panel">
                        <>
                            <div className="notifications">
                                <h2 className="notifications_heading">Latest Changes</h2>
                                <div
                                    onClick={() => {
                                        setShowNoti((prev) => !prev);
                                    }}
                                    className="notifications_close"
                                >
                                    <CloseIcon />
                                </div>
                                <div className="notifications_noti">
                                    <NotificationMessage
                                        type="orange"
                                        title="returns disposal disabled for all your RTO Orders."
                                        msg=" Dear merchants, As per our return policy, all rerurned to origin (RTO) orders are shipped back..."
                                    />
                                    <NotificationMessage
                                        type="blue"
                                        title="returns disposal disabled for all your RTO Orders."
                                        msg=" Dear merchants, As per our return policy, all rerurned to origin (RTO) orders are shipped back..."
                                    />
                                    <NotificationMessage
                                        type="orange"
                                        title="returns disposal disabled for all your RTO Orders."
                                        msg=" Dear merchants, As per our return policy, all rerurned to origin (RTO) orders are shipped back..."
                                    />
                                    <NotificationMessage
                                        type="orange"
                                        title="returns disposal disabled for all your RTO Orders."
                                        msg=" Dear merchants, As per our return policy, all rerurned to origin (RTO) orders are shipped back..."
                                    />
                                    <NotificationMessage
                                        type="blue"
                                        title="returns disposal disabled for all your RTO Orders."
                                        msg=" Dear merchants, As per our return policy, all rerurned to origin (RTO) orders are shipped back..."
                                    />
                                    <NotificationMessage
                                        type="orange"
                                        title="returns disposal disabled for all your RTO Orders."
                                        msg=" Dear merchants, As per our return policy, all rerurned to origin (RTO) orders are shipped back..."
                                    />
                                </div>
                                {/* <p className="notifications_foot">
                                    <span style={{ textDecoration: 'underline' }}>Cogminds updates</span> powered by{' '}
                                    <span style={{ textDecoration: 'underline' }}>Headway</span>
                                </p> */}
                            </div>
                            <BackDropModal
                                close={() => {
                                    setShowNoti(false);
                                }}
                            />
                        </>
                    </CSSTransition>
                </div>
                <div
                    onClick={() => {
                        setTopup((prev) => !prev);
                    }}
                    className="header_wallet"
                >
                    <p className="header_wallet_amount">₹ {walletMoney}.00</p>
                    <img src={Wallet} alt="Walllet" className="header_wallet_image" />
                    <p className="header_wallet_popup">Add Credit</p>
                </div>
                <div className="header_user">
                    <p
                        onClick={() => {
                            showProfilePopup((prev) => !prev);
                        }}
                        className="header_user_name"
                    >
                        Hii, <strong>{name}</strong>
                    </p>
                    <img
                        onClick={() => {
                            showProfilePopup((prev) => !prev);
                        }}
                        src={User}
                        alt="Avatar"
                        className="header_user_image"
                    />
                    <CSSTransition in={profilePopup} timeout={200} unmountOnExit classNames="header_notifcation_panel">
                        <>
                            <div className="profile_popup">
                                <div className="profile_popup_anv">
                                    {role === 'merchant' && (
                                        <p
                                            onClick={() => {
                                                hist.push('/main/settings/profile');
                                            }}
                                        >
                                            My Account
                                        </p>
                                    )}
                                    <p
                                        onClick={async () => {
                                            await logout();
                                        }}
                                    >
                                        <MeetingRoomIcon /> Logout
                                    </p>
                                </div>
                            </div>
                            <BackDropModal
                                close={() => {
                                    showProfilePopup(false);
                                }}
                            />
                        </>
                    </CSSTransition>
                </div>
            </div>
        </header>
    );
};

export default Index;
